import { getProductTypeUrlSuffix } from '../../../common/utilities/get-product-type-url-suffix';
import { getProductCatalogueApiConfig } from '../config/actions';
import { DEFAULT_ID_SEPARATOR } from '../constants/default-id-separator';
/**
 * @internal
 */
export var getFetchUrl = function (entityId, productType, includeType, subEntityType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    if (includeType === void 0) { includeType = "available" /* Available */; }
    var suffix = getProductTypeUrlSuffix(productType);
    var config = getProductCatalogueApiConfig();
    var url = config.baseUrl + "/v1/" + suffix + "/";
    if (Array.isArray(entityId)) {
        url += subEntityType ? "" + subEntityType : 'filter';
        url += "?ids=" + entityId.join(DEFAULT_ID_SEPARATOR) + "&";
    }
    else {
        url += "" + entityId;
        if (subEntityType) {
            url += "/" + subEntityType;
        }
        url += '?';
    }
    url += "include=" + includeType + "&marketLocale=" + config.marketLocale;
    return url;
};
